import { createContext } from 'react';
import { GetAccountsIbansParams } from '@goldwasserexchange/actor/rest-services';

export const accountsIbansParamsContext = createContext<Partial<GetAccountsIbansParams>>({});
